import React, {Component} from 'react';
import { withRouter } from 'react-router-dom';
import {Helmet} from "react-helmet";
import {Link} from 'react-router-dom';
import {Breadcrumb,} from 'semantic-ui-react';

import CustomDivider from '../../components/extras/CustomDivider';
import DynamicTable from "../../components/extras/DynamicTable";
import localDB from "../../data/localDB";
import UpgradeAccount from "../../components/extras/UpgradeAccount";
const c = require("../../constants");

class Unit extends Component{
    render(){
        return <span>
            {c.UNITS.find((unit) => unit.key===this.props.unit).text}
        </span>
    }
}

class ReportIngredientsStock extends Component {
    constructor(){
        super();
        this.state = {
            table: {
                headers: ['Producto', 'Unidades Disponibles', 'Unidad', 'Acciones'],
                name: 'Ingrediente',
                title: 'Ingredientes',
                has_actions: true,
                navigate: false,
                pagination: true,
                url: 'ingredient-stock-branch',
                values: ['id', 'name', 'total', 'unit'],
                component_fields:[{
                    unit: Unit
                }],
                id: 'table_report_stock'
            },
        }
    }

    render() {
        return (
            <div>
                <Helmet>
                    <title>Inventario de Ingredientes - Bisttros</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section as={Link} to='/reports'>Informes</Breadcrumb.Section>
                    <Breadcrumb.Divider/>
                    <Breadcrumb.Section active>Inventario de Ingredientes</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                {!localDB.checkPlanAccessExclude('ticket_service') ? <DynamicTable {...this.state.table} />:<UpgradeAccount/>}
            </div>
        );
    }
}

export default withRouter(ReportIngredientsStock);



// WEBPACK FOOTER //
// ./src/containers/reports/ReportIngredientsStock.js